import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";
import React from "react";
import { CartesianGrid, XAxis, YAxis, LineChart, Line } from "recharts";

export type TimelineChartPoint = {
    t: string;
    data: string | number;
};

export type StandardTimelineChartProps = {
    data: TimelineChartPoint[];
    label: string;
    color?: string;
    className?: string;
    valueFormatter?: (value: number) => ReactNode;
};

export const StandardTimelineChart = ({
    data,
    label,
    color = "var(--color-primary)",
    className,
    valueFormatter,
}: StandardTimelineChartProps): JSX.Element => {
    return (
        <ChartContainer
            config={{
                data: {
                    label,
                    color,
                },
            }}
            className={cn("h-48", className)}
        >
            <LineChart
                accessibilityLayer
                data={data}
                margin={{
                    left: 0,
                    right: 4,
                    top: 0,
                    bottom: 0,
                }}
            >
                <CartesianGrid vertical={false} />
                <XAxis dataKey="t" tickLine={false} axisLine={false} tickMargin={8} />
                <YAxis tickLine={false} axisLine={false} tickMargin={8} width={40} />
                <ChartTooltip
                    cursor={false}
                    content={<ChartTooltipContent hideLabel valueFormatter={valueFormatter} />}
                />
                <Line dataKey="data" type="linear" stroke={color} strokeWidth={2} dot={false} />
            </LineChart>
        </ChartContainer>
    );
};
